import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DownloadCertificateInput = () => {
  const [referenceNumber, setReferenceNumber] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!referenceNumber) {
      toast.error("Please enter a reference number.");
      return;
    }

    setLoading(true); // Start spinner

    try {
      const response = await fetch(`https://backend.impactjournal.co.in/manuscript/download-certificate/${referenceNumber}`);

      if (!response.ok) {
        throw new Error("Certificate not found.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${referenceNumber}_certificate.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      toast.error("Certificate not found or Do Login");
    } finally {
      setLoading(false); // Stop spinner
    }
  };

  return (
    <div className="tya-wrapper-impact">
      <ToastContainer position="top-center" autoClose={3000} />
      <h2 className="tya-heading-impact">Download Your Certificate</h2>
      <div className="tya-conatiner-pm">
        <div className="tya-procedure-to-track-pm">
          <div className="tya-tracking-container-pm">
            <p>Enter your reference number to download your certificate.</p>
            <div className="tya-input-track-pm">
              <input
                id="referenceNumber"
                type="text"
                className="tya-input-track"
                placeholder="Enter your reference number"
                value={referenceNumber}
                onChange={(e) => setReferenceNumber(e.target.value)}
              />
            </div>
            <div className="tya-track-btn-pm">
              <button className="tya-track-btn" onClick={handleDownload} disabled={loading}>
                {loading ? <span className="spinner"></span> : "Download Certificate"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadCertificateInput;
